import ChapterControlsContainer from "containers/ChapterControlsContainer";
import CSSTransitionGroup from "react-addons-css-transition-group";
import ChapterControlsInactiveSliderContainer from "containers/ChapterControlsInactiveSliderContainer";
import MobileChapterControls from "containers/MobileChapterControlsContainer";
import PropTypes from "prop-types";
import React from "react";
import UnmuteButton from "./UnmuteButton";
import styles from "./Controls.css";

export default function Controls(props) {
  let component;
  let compactComponent;
  if (props.showAdControls) {
    component = null;
  } else if (props.chapterId && props.useMobileControls) {
    component = (
      <MobileChapterControls
        active={props.active}
        chapterId={props.chapterId}
      />
    );
  } else if (props.showStandardControls && props.chapterId) {
    component = (
      <div className={styles.controls}>
        <ChapterControlsContainer
          active={props.active}
          chapterId={props.chapterId}
          key="regular-controls"
          onPlayClick={props.handleControlsPlayClick}
        />
      </div>
    );
  } else if (props.showCompactControls && props.chapterId) {
    compactComponent = (
      <ChapterControlsInactiveSliderContainer chapterId={props.chapterId} />
    );
  }

  const unmuteButton =
    props.showUnmuteButton && props.active ? <UnmuteButton /> : null;
  return (
    <div
      className={styles.root}
      onTouchStart={(e) => {
        e.stopPropagation();
        props.onReportActivity();
      }}
    >
      <CSSTransitionGroup
        transitionAppear={props.useAppearTransition}
        transitionAppearTimeout={1000}
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}
        transitionName={{
          appear: styles.transitionAppear,
          appearActive: styles.transitionAppearActive,
          enter: styles.transitionEnter,
          enterActive: styles.transitionEnterActive,
          leave: styles.transitionLeave,
          leaveActive: styles.transitionLeaveActive,
        }}
      >
        {unmuteButton}
        {component}
        {compactComponent}
      </CSSTransitionGroup>
    </div>
  );
}

Controls.propTypes = {
  active: PropTypes.bool.isRequired,
  chapterId: PropTypes.number,
  handleControlsPlayClick: PropTypes.func,
  height: PropTypes.number.isRequired,
  onReportActivity: PropTypes.func.isRequired,
  showAdControls: PropTypes.bool.isRequired,
  showCompactControls: PropTypes.bool.isRequired,
  showStandardControls: PropTypes.bool.isRequired,
  showUnmuteButton: PropTypes.bool.isRequired,
  useAppearTransition: PropTypes.bool.isRequired,
  useMobileControls: PropTypes.bool.isRequired,
};
